import React from "react";
import SvgIcon from "./SvgIcon";

const BackButton = (fallback = "/coaching-portal/athletes") => {
  const goBack = () => {
    if (history.length > 1) {
      history.back();
    } else {
      // Fallback: Redirect to a default page if no history exists
      location.href = fallback;
    }
  };

  return (
    <button
      data-button-type="tertiary"
      data-icon-only=""
      onClick={goBack}
      className="p-0 w-8! h-8!"
      type="button"
    >
      <SvgIcon
        src="/img/new-icons/arrow-square-left.svg"
        classNames="w-8! h-8!"
      />
    </button>
  );
};

export default BackButton;
